"use client"
import { useGetAPI } from "@/util/api/swr";
import EssencesGroup from "./EssencesGroup";

interface EssenceGroupProps {
  title: string;
  essences: {
    essence_url: string;
    essence_image: string;
    essence_image_alt: string;
    essence_title: string;
  }[];
}

interface EssenceType {
  id: number;
  essence_title: string;
  essence_second_title: string;
  essence_url: string;
  essence_image: string;
  essence_image_alt: string;
  Products: Product[];
  product_essence_group: number;
}

interface Product {
  id: number;
  ProductEssence: ProductEssence;
}

interface ProductEssence {
  product_essence_group: number;
}


const EssenceList = ({
  product,
  style,
}: {
  product: any;
  style: boolean;
}) => {
  const { data, isLoading } = useGetAPI(product?.id ? `/essence-product-id?id=${product?.id}` : null);
  const essenceFix = () => {
    const groupedEssences = [1, 2, 3, 4].reduce((acc, group) => {
      // Access the correct array inside the response object
      acc[group] = data?.data?.filter(
        (i: EssenceType) => i.product_essence_group === group
      ) || [];
      return acc;
    }, {} as Record<number, EssenceType[]>); // Ensure proper typing
    return groupedEssences;
  };


  const essence = essenceFix();

  return <EssencesGroup essence={essence} style={style} />
};

export default EssenceList;
